module.exports = __webpack_public_path__ + "static/media/The-Alan-Turing-Institute-logo.0e6bab7b.png";